import { Block, Typography } from "@xprog/prensa";
import { LoginButton } from "components/Buttons/LoginButton.index";
import { DotsBackground } from "components/DotsBackground/DotsBackground.index";
import GhostButton from "components/Buttons/GhostButton.index";
import { SubscriberInfoProps } from "components/SideMenu/SubscriberInfo/SubscriberInfo.types";
import React, { useContext } from "react";
import { SessionDataContext } from "providers/Session";

export const SubscriberInfo: React.FC<SubscriberInfoProps> = ({
  type,
  amountLeft,
  onLogin,
  onLogout,
}) => {
  const sessionData = useContext(SessionDataContext);

  const renderAnonymous = () => {
   
      return (
        <Block
          css={{
            height: "77px",
            width: "100%",
          }}
        >
          <DotsBackground
            css={{
              align: ["column", "center", "middle"],
              height: "100%",
            }}
          >
            <LoginButton onClick={onLogin}>Entrar</LoginButton>
          </DotsBackground>
        </Block>
      );

  };

  const renderGuestSubscriber = () => {
    return (
          <Block>
            <DotsBackground height="13px" />
            <Block
              css={{
                align: ["row", "between", "middle"],
                borderColor: "#E6E6E6",
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
                mx: "$3",
                pt: "$4",
                pb: "$5",
              }}
            >
              <Block
                css={{
                  align: ["row", "center", "middle"],
                }}
              >
                <Typography
                  as="span"
                  css={{
                    fontFamily: "$primary",
                    fontSize: "$caption3",
                    fontWeight: "$caption3",
                    lineBreak: "anywhere",
                    lineHeight: "$caption3",
                    ml: "$2",
                    mr: "$2",
                  }}
                >
                  {`Olá, ${
                    sessionData?.emailUsuario?.split("@")[0] || "Convidado"
                  }`}
                </Typography>
              </Block>
              <GhostButton
                css={{
                  button: {
                    cursor: "pointer",
                    height: "fit-content",
                    padding: "0px",
                    // mr: '$6'
                  },
                  label: {
                    color: "$primaryMain",
                    fontFamily: "$primary",
                    fontSize: "$caption3",
                    fontWeight: "$caption4",
                    lineHeight: "$caption3",
                  },
                }}
                onClick={onLogout}
              >
                Sair
              </GhostButton>
            </Block>
          </Block>
    );
  };

  const renderSubscriber = () => {
    return (
      <>
          <Block>
            <DotsBackground height="13px" />
            <Block
              css={{
                align: ["row", "between", "middle"],
                borderColor: "#E6E6E6",
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
                mx: "$7",
                py: "$4",
              }}
            >
              <Typography
                as="span"
                css={{
                  fontFamily: "$primary",
                  fontSize: "$caption3",
                  fontWeight: "$caption3",
                  lineHeight: "$caption3",
                  ml: "$2",
                }}
              >
                {`Olá, ${
                  sessionData?.emailUsuario?.split("@")[0] || "Convidado"
                }`}
              </Typography>
              <Typography
                as="span"
                onClick={onLogout}
                css={{
                  cursor: "pointer",
                  color: "$primaryMain",
                  fontFamily: "$primary",
                  fontSize: "$caption4",
                  fontWeight: "$caption4",
                  lineHeight: "$caption4",
                  mr: "$6",
                }}
              >
                Sair
              </Typography>
            </Block>
          </Block>
      </>
    );
  };

  switch (type) {
    case "anonymous":
      return renderAnonymous();
    case "DEGUSTADOR":
      return renderGuestSubscriber();
    case "advertiser_subscriber":
    case "club_subscriber":
    case "ASSINANTE":
      return renderSubscriber();
  }
};
